import { USERS_ENDPOINT } from "Constants";
import { baseApi as api } from "Services";
import {
  AcceptUserInviteRequest,
  AcceptUserInviteResponse,
  InviteCreateUserRequest,
  InviteCreateUserResponse,
  ResendInviteUserRequest,
  ResendInviteUserResponse,
  VerifyUserInviteRequest,
  VerifyUserInviteResponse,
} from "../types";

const inviteApi = api.injectEndpoints({
  endpoints: (build) => ({
    inviteCreateUser: build.mutation<
      InviteCreateUserResponse,
      InviteCreateUserRequest
    >({
      query: (queryArg) => ({
        url: `${USERS_ENDPOINT}/users/create-and-invite`,
        method: "POST",
        body: queryArg.body,
      }),
      invalidatesTags: ["Users"],
    }),
    resendInviteUser: build.mutation<
      ResendInviteUserResponse,
      ResendInviteUserRequest
    >({
      query: (queryArg) => ({
        url: `${USERS_ENDPOINT}/users/invite/${queryArg.userId}/resend`,
        method: "POST",
      }),
    }),
    acceptInvite: build.mutation<
      AcceptUserInviteResponse,
      AcceptUserInviteRequest
    >({
      query: (queryArg) => ({
        url: `${USERS_ENDPOINT}/users/invite/complete/${queryArg.inviteToken}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    verifyUserInvite: build.query<
      VerifyUserInviteResponse,
      VerifyUserInviteRequest
    >({
      query: (queryArg) => ({
        url: `${USERS_ENDPOINT}/users/invite/verify/${queryArg.inviteToken}`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useInviteCreateUserMutation,
  useResendInviteUserMutation,
  useAcceptInviteMutation,
  useVerifyUserInviteQuery,
} = inviteApi;
